import * as React from 'react';
import { ButtonGroup } from '../button-group/ButtonGroup';
import { Button } from '../button/Button';
import { Icon } from '../icon/Icon';
import { mcErase } from '@mc/react-ui-icons';
import { Menu } from '../menu/Menu';
import { MenuItem } from '../menu/MenuItem';
import { ClearFilterConfig } from '../rows-data/types';
import { FilterType } from './types';
import { FilterDef } from './Filters';

type Props = {
  type: FilterType;
  filtersDef: FilterDef[];
  getClearFilter: (config: ClearFilterConfig) => any;
  setNewFilter: (formFilter: any) => void;
  setVisibleFields?: (visibleFields?: string[]) => void;
  initialVisibleFields?: string[];
};

export const ClearFilter: React.FC<Props> = ({
  type,
  filtersDef,
  getClearFilter,
  initialVisibleFields,
  setVisibleFields,
  setNewFilter,
}) => {
  const clearFilters = () => {
    setNewFilter(getClearFilter({ type, filtersDef, initialFilter: false }));
  };
  const clearFiltersToDefault = () => {
    setNewFilter(getClearFilter({ type, filtersDef, initialFilter: true }));
    setVisibleFields?.(initialVisibleFields);
  };

  return (
    <ButtonGroup>
      <Button
        style={'default'}
        title={'Resetovat filtr'}
        icon={<Icon icon={mcErase} />}
        onClick={clearFilters}
        dataTest={'clear-filter'}
      />
      <Button
        style={'default'}
        dropdown
        menu={
          <Menu>
            <MenuItem text={'Výchozí filtr'} onClick={clearFiltersToDefault} />
          </Menu>
        }
      />
    </ButtonGroup>
  );
};
